import React from 'react'
import css from './style.scss'
import cn from 'classnames'
import {StatTitle} from './utils'


class TotalTime extends React.Component{
  constructor(props){
    super(props)
    this.state={
      totalTime:0,
      minutes:0,
      seconds:0,
      hours:0,
      days:0
    }
  }

  loadStats=(props)=>{
    let delta=props.stories.reduce((acc, s)=>{
      if(s.meta && s.meta.duration===0.04){s.meta.duration=3}
      return acc+((s.meta && s.meta.duration) || 3)
    }, 0).toFixed(2)
    if(delta === 0){
      this.setState({days:0, hours:0, minutes:0, seconds:0});
      return
    }
    let days = Math.floor(delta / 86400);
    if(days){delta -= days * 86400}

    // calculate (and subtract) whole hours
    let hours = Math.floor(delta / 3600) % 24;
    if(hours){delta -= hours * 3600}

    // calculate (and subtract) whole minutes
    let minutes = Math.floor(delta / 60) % 60;
    if(minutes){delta -= minutes * 60}

    // what's left is seconds
    let seconds = delta % 60;
    this.setState({totalTime:delta, days, hours, minutes, seconds})
  }
  componentDidMount(){
    this.loadStats(this.props)
  }
  componentWillReceiveProps(props){
    this.loadStats(props)
  }

  renderTime(){
    let s=""
    console.log(this.state.seconds);
    s=s+(this.state.days ? this.state.days + (this.state.days >=2 ? " days, " : " day, ") : "")
    s=s+(this.state.hours ? this.state.hours + (this.state.hours >= 2 ? " hours, " : " hour, ") : "")
    s=s+(this.state.minutes ? this.state.minutes + (this.state.minutes>=2 ? " minutes and " : " minute and ") :"")
    s=s + parseInt(this.state.seconds) + " seconds"
    return s;
  }
  render(){
    return (
      <div className={cn(this.props.className, css.statsBox)}>
        <StatTitle>Total Time</StatTitle>
        <div>
          <div className={css.timeContainer}>
          <small>In this
            {this.props.adventure ? " adventure" : " time frame"},
            {this.props.account_name ? " "+this.props.account_name+" " : " you "}
           shared</small>
          <div className={css.bigTime}>
            <b>{this.renderTime()}</b>
          </div>
          <small>of {this.props.account_name ? " his/her " : " your "} life on Instagram.</small>
          </div>
        </div>
      </div>
    )
  }
}

export default TotalTime;



// WEBPACK FOOTER //
// ./src/components/account_page/stats/sections/totalTime.js